<template>
  <section>
    <PageName title="Сотрудники ОСР"/>

    <div class="header__page">
      <div class="flex jc-sb gap-20 ai-fs">
        <VInput
          v-model="search"
          @enter="searchUsers"
          icon="search"
          width="469px"
          placeholder="Поиск по сотрудникам ОСР"
        />

        <VSwitch v-model="isTrashed" label="Показать удалённые" @valueChange="getTrashedItems" class="mt-5" />
      </div>

      <div class="buttons">
        <Button
          v-for="(button, i) in buttons"
          v-show="!button.hide"
          :key="'head' + i"
          :text="button.text"
          :icon="button.icon"
          width="100%"
          :iconWidth="button.iconWidth || '15px'"
          class="buttons__item"
          @click="button.event"
        />
      </div>
    </div>

    <Preloader v-if="rolesLoading" />

    <VTable
        v-show="!rolesLoading"
        itemsType="array"
        :columns="usersColumns"
        :items="mapedUsers"
        :sortApi="sortUsers"
        :selectedIndices="selectedIndices"
        @select="select"
        @row-click="openUser"
        selectable
        ref="table"
        isUser
    />
    <PagePagination
        v-if="pagination.lastPage > 1"
        :pageList="pagination.pageList"
        :currentPage="pagination.currentPage"
        @get-page="getPage"
    />
  </section>
</template>

<script>
import PagePagination from "@/components/PagePagination";
import PageName from "@/components/PageName";
import VTable from "@/components/Table/VTable";
import VInput from "@/components/Form/Vinput/Vinput.vue";
// import { phone } from "@/utils/filters/formatFilters";
import { mapState, mapActions } from "vuex";
import Preloader from "@/components/Preloader";
import Button from "@/components/Button.vue";
import VSwitch from "@/components/VSwitch.vue";
import { mixinAdminPanelUsers } from "@/mixins/users/mixinAdminPanelUsers";

export default {
  name: "Logisticians",
  components: {
    VSwitch,
    PagePagination,
    PageName,
    VTable,
    VInput,
    Preloader,
    Button
  },
  mixins: [mixinAdminPanelUsers],
  data() {
    return {
      usersColumns: [
        { title: "№", sort: true, value: "id" },
        { title: "Cоздан", sort: true, value: "created_at" },
        { title: "Изменен", sort: true, value: "updated_at" },
        { title: "Фамилия", sort: true, value: "surname" },
        { title: "Имя", sort: true, value: "name" },
        { title: "Отчество", sort: true, value: "patronymic" },
        { title: "Логин", sort: true, value: "email" },
        { title: "Подразделение", sort: true, value: "departments.name" },
        { title: "Номер служебного телефона", sort: true, value: "phone" },
      ],
      buttons: [
        {
          text: "Восстановить",
          icon: "user_restore",
          event: this.restore || this.callback,
        },
        {
          text: "Создать",
          icon: "addFile",
          event: this.create || this.callback,
        },
        {
          text: "Удалить",
          icon: "delete",
          event: this.delete || this.callback,
          iconWidth: "12px",
        },
      ],

      roleId: 4,
      urlSave: '/admin-panel/save/osr-staff',
      urlProfile: '/admin-panel/profile/osr-staff/'
    };
  },
  computed: {
    ...mapState("users", {
      users: "OSRstaff",
      rolesLoading: "rolesLoading",
    }),
  },
  methods: {
    ...mapActions("users", ["getUsersWithRole"]),

    getUsersByParams (params) {
      this.$store.dispatch('users/getUsersRolesListPage', params)
    }
  }
}
</script>

<style scoped lang="scss"></style>
